const categoryRouter = [
  {
      path: "list-category",
      name: "category",
      component: () => import("@/views/admin/category"),
      default: true,
      meta: {
          model: "category",
          // requiresAuth: true,
      },
  },
  {
      path: "list-category/add",
      name: "addCategory",
      component: () => import("@/views/admin/category/function"),
      default: true,
      meta: {
          model: "category",
          // requiresAuth: true,
      },
  },
  {
      path: "list-category/edit/:id",
      name: "editCategory",
      component: () => import("@/views/admin/category/function"),
      default: true,
      meta: {
          model: "category",
          // requiresAuth: true,
      },
  }
]
export default categoryRouter;